'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var PaginationButton = function PaginationButton(_ref) {
  var text = _ref.text,
    active = _ref.active,
    _onClick = _ref.onClick,
    scrollId = _ref.scrollId;
  return /*#__PURE__*/React__default.default.createElement("button", {
    className: "pagination-button ".concat(active ? 'active' : ''),
    onClick: function onClick() {
      if (text !== '...') {
        _onClick();
        var element = document.getElementById(scrollId);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    }
  }, text);
};
PaginationButton.defaultProps = {
  scrollId: 'pagination-top'
};
PaginationButton.propTypes = {
  active: PropTypes__default.default.bool,
  onClick: PropTypes__default.default.func,
  scrollId: PropTypes__default.default.string,
  text: PropTypes__default.default.oneOfType([PropTypes__default.default.string, PropTypes__default.default.number])
};

exports.PaginationButton = PaginationButton;
exports.default = PaginationButton;
//# sourceMappingURL=PaginationButton.js.map
